/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import uniq from 'hs-lodash/uniq';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isSingleTruthyValue from 'forms-utils-lib/utils/array/isSingleTruthyValue';
import UsersAndTeamsAssetAccessPanelWithDataFetching from 'ui-asset-management-lib/components/UsersAndTeamsAssetAccessPanelWithDataFetching';
import useFetchFormPermissions from 'asset-actions-lib-forms/permissions/hooks/useFetchFormPermissions';
import useSetFormPermissions from 'asset-actions-lib-forms/permissions/hooks/useSetFormPermissions';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ManageAccessDescription = ({
  formGuids = [],
  formBusinessUnitsIds = [],
  displayBusinessUnitsInfo = true,
  BusinessUnitTagContainer
}) => {
  const formCount = formGuids.length;
  const uniqueBusinessUnitIds = uniq(formBusinessUnitsIds);
  const businessUnitsCount = uniqueBusinessUnitIds.length;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      children: displayBusinessUnitsInfo ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'formAccessPanel.formsBusinessUnitsDescriptionOne',
          options: {
            count: formCount
          }
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'formAccessPanel.formsBusinessUnitsDescriptionTwo',
          options: {
            count: businessUnitsCount
          }
        })]
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: 'formAccessPanel.formsDescription',
        options: {
          formCount
        }
      })
    }), displayBusinessUnitsInfo ? /*#__PURE__*/_jsx("div", {
      children: uniqueBusinessUnitIds.map(businessUnitId => /*#__PURE__*/_jsx(BusinessUnitTagContainer, {
        buId: businessUnitId
      }, businessUnitId))
    }) : null]
  });
};
const FormPermissionsActionPanel = ({
  formGuids = [],
  formBusinessUnitsIds = [],
  onClosePanel = () => {},
  hasBusinessUnitsAccess = false,
  track = () => {},
  BusinessUnitTagContainer
}) => {
  const {
    permissions: {
      userIds,
      teamIds
    },
    loading: fetchFormPermissionsLoading
  } = useFetchFormPermissions(formGuids);
  const {
    handleSetFormPermissions,
    loading: setFormPermissionsLoading,
    error: setFormPermissionsError
  } = useSetFormPermissions(formGuids, onClosePanel);
  return /*#__PURE__*/_jsx(UsersAndTeamsAssetAccessPanelWithDataFetching, {
    description: /*#__PURE__*/_jsx(ManageAccessDescription, {
      formGuids: formGuids,
      formBusinessUnitsIds: formBusinessUnitsIds,
      displayBusinessUnitsInfo: hasBusinessUnitsAccess,
      BusinessUnitTagContainer: BusinessUnitTagContainer
    }),
    assignedUserIds: userIds,
    assignedTeamIds: teamIds,
    onCancel: onClosePanel,
    onSave: updatedPermissions => {
      track('save-assign-permissions');
      handleSetFormPermissions(updatedPermissions);
    },
    requestsLoading: isSingleTruthyValue(formGuids) && fetchFormPermissionsLoading,
    showSaveLoading: setFormPermissionsLoading,
    showSaveFailed: setFormPermissionsError
  });
};
export default FormPermissionsActionPanel;